import Link from "next/link";

const Breadcrumbs = ({ breadcrumbs, className = "text-black" }) => {
  return (
    <nav aria-label="breadcrumb">
      <div className="flex text-base text-gray-600 py-2 list-none mx-5">
        {breadcrumbs.map((breadcrumb, index) => (
          <div key={index} className="pr-2">
            {index !== 0 && <span className={`${className} text-base pr-2`}>/</span>}
            {breadcrumb.href ? (
              <Link href={breadcrumb.href} className={`${className} text-base`}>
                <span className="hover:underline">{breadcrumb.label}</span>
              </Link>
            ) : (
              <span>{breadcrumb.label}</span>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumbs;
